import {
	orderValues,
	operatorValues,
	filterValues,
	booleanValues,
} from "../../../constants";

export const orderOptions = [
	{ value: orderValues.ASC, label: `order.${orderValues.ASC}` },
	{ value: orderValues.DESC, label: `order.${orderValues.DESC}` },
];

export const operatorOptions = [
	{
		value: operatorValues.CONTAINS,
		label: `operator.${operatorValues.CONTAINS}`,
	},
	{
		value: operatorValues.ONE_OF,
		label: `operator.${operatorValues.ONE_OF}`,
	},
	{ value: operatorValues.EXACT, label: `operator.${operatorValues.EXACT}` },
	{
		value: operatorValues.EXISTS,
		label: `operator.${operatorValues.EXISTS}`,
	},
	{
		value: operatorValues.GREATER_THAN,
		label: `operator.${operatorValues.GREATER_THAN}`,
	},
	{
		value: operatorValues.GREATER_THAN_EQUAL,
		label: `operator.${operatorValues.GREATER_THAN_EQUAL}`,
	},
	{
		value: operatorValues.LESS_THAN,
		label: `operator.${operatorValues.LESS_THAN}`,
	},
	{
		value: operatorValues.LESS_THAN_EQUAL,
		label: `operator.${operatorValues.LESS_THAN_EQUAL}`,
	},
];

export const filterOptions = [
	{ value: filterValues.AND, label: `filter.${filterValues.AND}` },
	{ value: filterValues.OR, label: `filter.${filterValues.OR}` },
	{ value: filterValues.NOT, label: `filter.${filterValues.NOT}` },
];

export const booleanOptions = [
	{ value: booleanValues.TRUE, label: `boolean.${booleanValues.TRUE}` },
	{ value: booleanValues.FALSE, label: `boolean.${booleanValues.FALSE}` },
];
